module.exports = __webpack_public_path__ + "img/service_frontend_3_mob_2x.8435932b.jpg";